import React, { useState, useEffect, useRef, useContext } from 'react';
import './ProPilot.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Header from '@/v2/components/application/Header';
import TimelineText from '@/v2/components/atoms/TimelineText';
import Button from '@/v2/components/atoms/Button';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DriverAssistContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const STATE = {
    none: 'none',
    intro: 'intro',
    cta: 'cta',
    end: 'end',
};

const videoReady = (controller, setTime, onReady) => {
    videoController = controller;
    videoController.AddOnTimeUpdated(() => setTime(videoController.GetTime()));

    onReady();
};

const stateIntro = () => {
    videoController.Play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [state, setState] = useState(STATE.none);
    const [btnAnimate, setBtnAnimate] = useState('in');
    const [{ disclaimer }] = useContext(DriverAssistContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    const btnHandler = () => {
        setBtnAnimate('out');
        timeout(() => {
            onFinished();
        }, 800);
    };

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
            setState(STATE.intro);
        }
    }, [isActive, videoController]);

    useEffect(() => {
        switch (state) {
            case STATE.intro:
                stateIntro();
                break;
            default:
        }
    }, [state]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, time.current.Set, onReady),
        autoPlay: true,
        onFinished: () => setState(STATE.cta),
    };

    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    return (
        <div className="ProPilot">
            <VideoSimple src={data.video} options={options} />
            <Header show={isActive} animate hideLogo dark />
            {state !== STATE.cta && <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" />}
            {state === STATE.cta && (
                <div className="ProPilot__cta">
                    <Button
                        variant="base"
                        animate={btnAnimate}
                        onClick={() => {
                            btnHandler();
                        }}
                    >
                        {data.text.cta.continue}
                    </Button>
                </div>
            )}
            {disclaimerContent}
        </div>
    );
};
